<template>
  <div>
    <mdb-tbl hover striped sm>
      <mdb-tbl-head>
        <tr class='table-header'>
          <th>No</th>
          <th>사용자 ID</th>
          <th>이름</th>
          <th>email</th>
          <th>핸드폰</th>
          <th v-if="isAdmin" style="width:60px" ></th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(t, index) in teachers" :key="index">
          <td>{{startIndex + index+1}}</td>
          <td>{{t.userId}}</td>
          <td>{{t.name}}</td>
          <td>{{t.email}}</td>
          <td><span  v-if="t.cellPhone">{{t.cellPhone.number1}}-{{t.cellPhone.number2}}-{{t.cellPhone.number3}}</span></td>
          <td v-if="isAdmin">
            <mdb-btn icon="edit" class="p-0 m-0 mr-1" sm @click="$emit('edit-user', t)"/>
            <mdb-btn icon="trash" color="danger" class="m-0 p-0" sm @click="$emit('delete-user', t)"/>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
export default {
  name: 'StaffList',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['teachers', 'startIndex'],
  computed: mapGetters('auth', ['isAdmin']),
  data: () => ({
  })
}
</script>
